// Theme-id classification helpers, kept in a LEAF module with no imports. Low-level consumers
// (e.g. dashboardHelpers) must use this instead of the themes barrel: themes.ts transitively
// imports app constants → packages/utils, and pulling that graph from helper modules creates
// module-initialization cycles (it broke the tests/ jest project via useBlockRender).

/** Prefix used for custom/branded theme ids: `custom:{uuid}`. */
export const CUSTOM_THEME_ID_PREFIX = "custom:";

/** True for palette selector ids of the form `palette:{slug}`. */
export const isPaletteThemeId = (themeId: string): boolean => themeId.startsWith("palette:");

/** True for custom/branded theme ids of the form `custom:{uuid}`. */
export const isCustomThemeId = (themeId: string | undefined | null): boolean =>
  !!themeId && themeId.startsWith(CUSTOM_THEME_ID_PREFIX);

/**
 * True when the (mode, background) toggles actually change the resolved theme — palette/custom ids
 * only. Legacy slug themes render as authored and ignore the toggles, so callers keying re-renders
 * off the theme (e.g. `themeSignature`) must not churn on toggle flips for them.
 */
export const isToggleAwareThemeId = (themeId: string): boolean =>
  isPaletteThemeId(themeId) || isCustomThemeId(themeId);
